$(document).ready(function(){
  
	populate_field('Product Category', 'values?asset=product_categories', '#product_categories', true);
	populate_field('State', 'values?asset=state', '#state', true);

	$('#product_categories').change(function(){
     //! CODE USER: To clear search-input fields and their corresponding values
     $('#model').val('')
     $('#model').attr('data-value',"")
     $('#model').attr('data-key',"")
     $('#model-ul').html('<li class="model-search-item-dummy" >Select Model *</li>')
	  populate_field('Product', 'values?asset=products&filter='+$(this).val()+'&filter_col=3', '#products', $(this).val());
	});  

	$('#products').change(function(){
    //! CODE USER: To clear search-input fields and their corresponding values
    $("#model-ul").html("") 
    $('#model').val('')
    $('#model').attr('data-value',"")
    $('#model').attr('data-key',"")
	  populate_field_search('Model', 'values?asset=model&filter='+$(this).val()+'&filter_col=0', '#model', $(this).val());
	});
	  
	$('#state').change(function(){
	  populate_field('City', 'values?asset=city&filter='+$(this).val()+'&filter_col=2', '#city', $(this).val());
	});  

	$('#city').change(function(){
	  populate_field('Area', 'values?asset=area&filter='+$(this).val()+'&filter_col=2', '#area', $(this).val());
	});

  $("#area").change(function(){
    populate_field('Pincode', 'values?asset=pincode&filter='+$(this).val().split("|")[1]+'&filter_col=2', '#pincode', $(this).val());
  });


  $('#model').on('click',function(){
    if($("#model-ul").hasClass('hidden')){
      $("#model-ul").removeClass("hidden")
    }else{
      $('#model-ul').addClass('hidden')
    }
  })

function populate_field(field, slug, field_id, parent){
  $.ajax({url: 'https://orientform.marmeto.com/'+slug, success: function(response){
  $(field_id).html('<option value="" disabled selected>Select '+field+' *</option>');
  if($(field_id).length > 0 && parent){
    data = response.data;
    $(data).each(function(){
    if(field == 'Product'){
      $(field_id).append('<option value="'+this.value+'" data-id="'+this.lookupCode+'">'+this.description+'</option>');
      const data = $('model-ul')
    }else if(field == 'Area'){
      $(field_id).append(`<option value="${this.description}|${this.lookupCode}">${this.description}</option>`);
    }else if(field == 'Pincode'){
      $(field_id).append('<option value="'+this.description+'">'+this.description+'</option>');
    }else{
      $(field_id).append('<option value="'+this.lookupCode+'">'+this.description+'</option>');
    }
    });
  }
  }});
}

//! CODE USE: To populate values of search options
function populate_field_search(field, slug, field_id, parent){
  $.ajax({url: 'https://orientform.marmeto.com/'+slug, success: function(response){
    let tag_id = field_id + '-ul'
    if($(field_id).length > 0 && parent){
      data = response.data;
      $(data).each(function(){
        $(tag_id).append('<li class="model-search-item" data-value="'+this.lookupCode+'">'+this.description+'</li>');
      });
    }
  }});
}


//! CODE USE: To achive select box functionality (Hide options on outside click)
$(document).on('click',function(e){
  const ele =  e.target
  if($(ele).attr('name') != 'contact[Model]' && !$(ele).hasClass('model-search-item')){
    $('#model-ul').addClass("hidden");
    let text = $('#model').attr('data-key')
    $('#model').val(text)
  }
})

$('#model').keyup(search_items);

//! FUNCTION USE: Filter options (search functionality)
function search_items(){
  if($("#model-ul").hasClass('hidden')){
    $("#model-ul").removeClass("hidden")
  }
  let input = document.querySelector('#model').value;
  input = input.toLowerCase();
  let modelSearchItem = $('.model-search-item');
  for (i = 0; i < modelSearchItem.length; i++) {
    if (!modelSearchItem[i].innerHTML.toLowerCase().includes(input)) {
      modelSearchItem[i].style.display = "none";
    }
    else {
      modelSearchItem[i].style.display = "list-item";
    }
  }
}

//! CODE USE: Click on input box hide options 
$("#model-ul").on('click','li',function(ele){
  $('#model').val(ele.currentTarget.innerText)
  $('#model').attr('data-value',ele.currentTarget.dataset.value)
  $('#model').attr('data-key',ele.currentTarget.innerText)
  $('#model-ul').addClass('hidden')
})

const formOverlay = document.getElementById("overlay");
const body = document.body;

//! Function to open the overlay
function openFormOverlay() {
    overlay.classList.remove("hidden");
    body.classList.add("overflow-hidden");
}

//! Function to close the overlay
function closeFormOverlay() {
    overlay.classList.add("hidden");
    body.classList.remove("overflow-hidden");
   $(".complaint-otp-login-popup").addClass("hidden");
   $("#complaint-mobile-number").show();
}

  $('#ContactForm').submit(function(e){
      e.preventDefault();
      let valid = true;
      if(!email_validation()){ valid = false; };
      if(!empty_field_validation()){ valid = false; };
      if(!phone_validation()){ valid = false; };
      if(valid){
          $('#ContactForm').find('button[type="submit"]').addClass('loading');
          const verificationToken = sessionStorage.getItem("complaintVerificationToken");
          let customerTypes = {
            3 : "Customer",
            7 : "Employee",
            1 : "Dealer"
          }
          let formData = {
            'product_category': $("#product_categories").val(),
            'products': $("#products").find(':selected').data('id'),
            'model': $("#model").data('value'),
            'issue': $("#issue").text(),
            'requested_by': $("#requested_by").val(),
            'message': $("#message").val(),
            'name': $("#name_name").val(),
            'mobileNumber': $("#phone").val(),
            'email': $("#email_email").val(),
            'address': $("#address").val(),
            'country': $("#country").val(),
            'state': $("#state").val(),
            'city': $("#city").val(),
            'area': $("#area").val().split("|")[0],
            'pincode': $("#pincode").val(),
            'customerType': customerTypes[$("#requested_by").val()]
          };
          let settings = {
            "url": "https://orientform.marmeto.com/api/complient",
            "method": "POST",
            "timeout": 0,
            "headers": {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + verificationToken
            },
             "data": JSON.stringify(formData)
          };
          $.ajax(settings).done(function(response){
             closeFormOverlay();
            if (response.statusCode < 400) {
                $('#form_response').text("Thank you for registering your complaint. We appreciate your patience and will connect with you soon to promptly resolve your issue.");
            } else {
                // Show API response message
                $('#form_response').text(response.messageDescription);
            }
            lity('#contact_form_main_popup_response');
            $('#contact_form_main_popup .lity-close').trigger('click');
            $('#ContactForm').find('button[type="submit"]').removeClass('loading');
            $("#product_categories, #products, #model, #issue, #requested_by, #message, #name, #phone, #email, #address, #country, #state, #city, #area, #pincode").val('');
          });
      }
    return false;
});

$('#complaint-register').on("click", 
  (event) => {
    event.preventDefault();
   $(".complaint-otp-login-popup").removeClass("hidden");
    $("body").attr("overflow", "hidden");
    $("body").addClass("overflow-hidden");
}); 

$('#enquiryForm').submit(
	function(e){
    e.preventDefault();
    let valid = true;
    if(!email_validation()){ valid = false; };
    if(!empty_field_validation()){ valid = false; };
    if(!phone_validation()){ valid = false; };
    if(!valid){
      return;
    }
    if(valid){
    $('#enquiryForm').find('button[type="submit"]').addClass('loading');
		let productSku = $("#message").attr('data-sku') || 'SKU Not available';
		let productTitle = $("#message").attr('data-product-title');
		let quantity = $("#quantity").val();
		let formData = {
			'query_type': "Sales",
			'name': $("#user-name").val(),
			'country': "India",
			'state': $("#state").val(),
			'city': $("#city").val(),
			'pincode': $("#pincode").val(),
			'mobile_number': $("#phone").val(),
			'email': $("#user-email").val(),
			'product_category': $('#product_categories').val(),
			'organisation': $("#organisation").val(),
    		'message': `${(productTitle)? (`Product Title: ${productTitle}, SKU: ${productSku}, Quantity: ${quantity}, Message:`):('')}` + $("#message").val()
		};
		let settings = {
			"url": "https://orientform.marmeto.com/api/enquiry",
			"method": "POST",
			"timeout": 0,
			"headers": {
			"Content-Type": "application/json"
			},
			"data": JSON.stringify(formData)
		};
      
      $.ajax(settings).done(function(response){
        $('#form_response').text(response.status);
         $('.product-popup-modal .product-popup-modal__toggle').trigger('click');
        lity('#enquiry_form_main_popup_response');
        $('#enquiryForm').find('button[type="submit"]').removeClass('loading');
        $("#name0, #state, #city, #pincode, #phone, #email, #product_categories, #organisation, #message").val('');
      });
    }
  }); 
});  



function empty_field_validation(){
  let empty_field_check = true;
  $('#ContactForm, #enquiryForm').find('.required').each(function(){
    if($(this).attr('name')==`contact[Model]`){
      if($(this).attr('data-value')){
        $(this).parent('.field_wrap').removeClass('error blank-error');	
      }else{
        $(this).parent('.field_wrap').addClass('error blank-error');
        empty_field_check = false;
      }
    }else{
      if($(this).val()){
        $(this).parent('.field_wrap').removeClass('error blank-error');	
      }else{
        $(this).parent('.field_wrap').addClass('error blank-error');
        empty_field_check = false;
      }
    }
  });
  return empty_field_check;
}

// Email Field Validation
function IsEmail(email) {
  let regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if(!regex.test(email)) {
	return false;
  } else {
	return true;
  }
}

function email_validation(){
  let email_check = true;
  $('#ContactForm, #enquiryForm').find('.email').each(function(){
	if(IsEmail($(this).val())){
	  $(this).parent('.field_wrap').removeClass('error email-error');
	}else{
	  $(this).parent('.field_wrap').addClass('error email-error');
	  email_check = false;
	}
  });
  return email_check;
}

//! Phone Field Validation
function phone_validation(){
  let phone_check = true;
  intRegex = /[0-9 -()+]+$/;  
  $('#ContactForm, #enquiryForm').find('.phone').each(function(){
	let phone = $(this).val();
	if((phone.length < 10) || (phone.length > 10) || (!intRegex.test(phone))){
	  $(this).parent('.field_wrap').addClass('error phone-error');
	  phone_check = false;
	}else{
	  $(this).parent('.field_wrap').removeClass('error phone-error');
	}
  });
  return phone_check;  
}

function _isNumberKey(evt) {
	let charCode = (evt.which) ? evt.which : event.keyCode
	if (charCode > 31 && (charCode < 48 || charCode > 57))
		return false;
	return true;
}

function _isCharacterKey(evt) {
	let charCode = (evt.which) ? evt.which : event.keyCode
	if (charCode == 32 || (charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123))
		return true;
	return false;
}
  
function _isEmailChar(evt) {
	let charCode = (evt.which) ? evt.which : event.keyCode
	if (charCode == 46 || (charCode > 47 && charCode < 58) || (charCode > 63 && charCode < 91) || (charCode > 96 && charCode < 123))
		return true;
	return false;
}

//! Allow only number in Phone field
$('.phone').keypress(function(event) {
	return _isNumberKey(event)
});

//! Allow only number in Quantity field
$('#quantity').keypress(function(event) {
	return _isNumberKey(event)
});

//! Allow only characters in Name field
$('.name-field').keypress(function(event) {
	return _isCharacterKey(event)
});

// Allow only characters, @ and . in Email field
$('.email').keypress(function(event) {
	return _isEmailChar(event)
});  
  
//! Validations while typing
$('input, textarea').keyup(function() {
 if($(this).attr('name') != 'contact[Model]'){
  if($(this).val() !== ''){
    $(this).parent('.field_wrap').removeClass('error blank-error');
    }else{
    $(this).parent('.field_wrap').addClass('error blank-error');
    }
 }
});

$('select').change(function() {
  if($(this).val() !== ''){
	$(this).parent('.field_wrap').removeClass('error blank-error');
  }else{
	$(this).parent('.field_wrap').addClass('error blank-error');
  }
});

$('.email').keyup(function() {
  if(IsEmail($(this).val())){
	$(this).parent('.field_wrap').removeClass('error email-error');
  }else{
	$(this).parent('.field_wrap').addClass('error email-error');
  }
});

$('.phone').keyup(function() {
  intRegex = /[0-9 -()+]+$/;
  let phone = $(this).val();
  if((phone.length < 10) || (phone.length > 10) || (!intRegex.test(phone))){
	$(this).parent('.field_wrap').addClass('error phone-error');
  }else{
	$(this).parent('.field_wrap').removeClass('error phone-error');
  }
});

$(".terms-condition-popup-close").on('click',function(){
  $(".lity-close").removeClass("hidden")
  const termsAndConditionContainer =  $(".terms-and-condition-container").hasClass("hidden")
  if(!termsAndConditionContainer){
      $(".terms-and-condition-container").addClass("hidden")
  }
})

$(".terms-and-condition-popup").on('click',function(){
  $(".lity-close").addClass("hidden")
const val =  $(".terms-and-condition-container").hasClass("hidden")
  if(val){
      $(".terms-and-condition-container").removeClass("hidden")  
  }
})

$("#terms-and-condition-3").change(function(e){
  if(!e.target.checked){
   $("#register-button-3").attr("disabled",true);
  }else{
   $("#register-button-3").removeAttr("disabled");
  }
 });

 $("#terms-and-condition-4").change(function(e){
  if(!e.target.checked){
   $("#register-button-4").attr("disabled",true);
  }else{
   $("#register-button-4").removeAttr("disabled");
  }
 });

 $(".terms-condition-popup-close-enquiry").on('click',function(){
  const enquiryPageTerms =  $(".enquiry-page-terms").hasClass("hidden")
  if(!enquiryPageTerms){
      $(".enquiry-page-terms").addClass("hidden")
      $('body').css('overflow', 'auto') 
  }
})


$(".terms-and-condition-popup-enquiry").on('click',function(e){
const enquiryPageTerms =  $(".enquiry-page-terms").hasClass("hidden")
  if(enquiryPageTerms){
      $(".enquiry-page-terms").removeClass("hidden") 
      $('body').css('overflow', 'hidden') 
  }
})
